import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]

import { computed, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox.vue";
import { useStore } from "vuex";
import * as dtos from "@/models/dtos";
const classSmall = "col-sm-5 col-md-5";
const classLarge = "col-sm-7 col-md-7";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputCheckboxGroup',
  props: {
    model: {},
    keyId: {},
    placeholder: {},
    full: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

function getLabel(item: string) {
  const prop = store.getters.getformBuilderAllItems.find((px) => {
    return px.key == item;
  });
  return prop.label;
}

function getData(item: string) {
  const prop = store.getters.getformBuilderAllItems.find((px) => {
    return px.key == item;
  });
  return prop.data;
}
let model = ref(props.model);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("label", {
      class: "form-check-label",
      for: _ctx.keyId
    }, _toDisplayString(_ctx.placeholder), 9, _hoisted_1),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).keys, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(classLarge)
        }, [
          _createVNode(InputCheckbox, {
            class: "",
            keyId: `${item}-${index}`,
            placeholder: getLabel(item),
            model: getData(item),
            type: "checkbox",
            disabled: _ctx.disabled
          }, null, 8, ["keyId", "placeholder", "model", "disabled"])
        ])
      ]))
    }), 128))
  ], 64))
}
}

})